export const dateFilterParams = {
  comparator: (filterDate, cellValue) => {
    if (!cellValue) return -1;

    const cellDateAtMidnight = new Date(
      cellValue.getFullYear(),
      cellValue.getMonth(),
      cellValue.getDate()
    );
    const filterDateAtMidnight = new Date(
      filterDate.getFullYear(),
      filterDate.getMonth(),
      filterDate.getDate()
    );

    if (cellDateAtMidnight.getTime() === filterDateAtMidnight.getTime())
      return 0;
    if (cellDateAtMidnight < filterDateAtMidnight) return -1;
    return 1;
  },
};
